import React from 'react'

import { Html } from '@application/Interfaces/Atoms/Html'
import { handleAccordionExpand } from '@application/Interfaces/Features/TitleDescriptionAccordion/utils'
import { ArrowDirectionIcon } from '@application/Interfaces/Icons'
import { TitleDescriptionAccordionType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import Container from '@mui/material/Container'

import { Accordion, AccordionDescription, Description, Link, Title, Wrapper } from './TitleDescriptionAccordion.styled'

export const TitleDescriptionAccordion = (props: TitleDescriptionAccordionType): JSX.Element => {
    const { className, mode, title, accordionDescription, actionLink, actionLabel, accordionItems, titlePosition } =
        props
    const [expanded, setExpanded] = React.useState<number | false>(false)

    const isTitleTopPosition = titlePosition === 'top'

    const columnWidth = isTitleTopPosition ? 12 : 6
    const columnRightSpacing = isTitleTopPosition ? 0 : 6
    const textAlignment = isTitleTopPosition ? 'center' : 'left'
    const mdUpSpacingTop = isTitleTopPosition ? 6 : 0
    const link =
        actionLink && actionLabel ? (
            <Link to={actionLink}>
                <span>{actionLabel}</span>
                <ArrowDirectionIcon colorCode={mode === 'Dark' ? 'white' : 'p500'} />
            </Link>
        ) : undefined

    return (
        <Wrapper $mode={mode} className={className}>
            <Container>
                <Grid container>
                    <Grid
                        container
                        item
                        xs={12}
                        sm={columnWidth}
                        mdUpSpacingRight={columnRightSpacing}
                        textAlign={textAlignment}
                        justifyContent="center"
                        direction="column"
                    >
                        <Grid item></Grid>
                        <Title>{title}</Title>
                        {accordionDescription && <Description>{accordionDescription}</Description>}
                        {!isTitleTopPosition && link}
                    </Grid>
                    <Grid item xs={12} sm={columnWidth} xsSpacingTop={6} mdUpSpacingTop={mdUpSpacingTop}>
                        {accordionItems.map((item, index) => (
                            <Accordion
                                isOpen={index === expanded}
                                key={index}
                                title={item.title}
                                className="description-accordion"
                                onChange={handleAccordionExpand(index, setExpanded)}
                            >
                                <AccordionDescription>
                                    <Html content={item.description.data.childMarkdownRemark.html} />
                                </AccordionDescription>
                            </Accordion>
                        ))}
                    </Grid>
                    {isTitleTopPosition && link && (
                        <Grid item xs={12} textAlign="center">
                            {link}
                        </Grid>
                    )}
                </Grid>
            </Container>
        </Wrapper>
    )
}
